export const saveOnLocalStorage = (value, state) => {
    localStorage.setItem(state, value)
}

export const getFromLocalStorage = (state) => {
    return localStorage.getItem(state);
}